import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=7a8aa3d4&lang=pug&"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=ts&"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=7a8aa3d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports